import { Database, Activity, Clock, BarChart } from 'lucide-react';

const FEEDS = [
  { name: 'STIX/TAXII — CISA Known Exploited', type: 'STIX', status: 'Active', lastSync: '2 min ago', indicators: 1247, frequency: 'Every 15 min' },
  { name: 'MISP — Malaysian CERT', type: 'MISP', status: 'Active', lastSync: '8 min ago', indicators: 892, frequency: 'Every 30 min' },
  { name: 'STIX/TAXII — MITRE ATT&CK', type: 'STIX', status: 'Active', lastSync: '12 min ago', indicators: 3456, frequency: 'Hourly' },
  { name: 'MISP — APAC Threat Intel', type: 'MISP', status: 'Active', lastSync: '45 min ago', indicators: 567, frequency: 'Hourly' },
  { name: 'OpenCTI — AlienVault OTX', type: 'OpenCTI', status: 'Inactive', lastSync: '3 hours ago', indicators: 0, frequency: 'Daily' },
  { name: 'STIX/TAXII — NCSC Feed', type: 'STIX', status: 'Active', lastSync: '1 min ago', indicators: 2140, frequency: 'Every 15 min' },
];

const FeedMonitoring = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Feed Monitoring</h1>
      <p className="text-sm text-gray-500 mt-1">
        Live status of STIX/TAXII and MISP ingestions · PRD: INTEL (Section 7.8)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Database className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">Intel Feeds</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEEDS.map((feed, i) => (
          <div key={i} className="bg-gray-950/60 border border-gray-800 rounded-lg p-4 hover:border-gray-700 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <span className="px-2 py-0.5 rounded text-xs font-mono font-medium bg-gray-800 text-gray-300">
                {feed.type}
              </span>
              <span className={`flex items-center gap-1 text-xs font-medium ${
                feed.status === 'Active' ? 'text-emerald-400' : 'text-red-400'
              }`}>
                <span className={`w-1.5 h-1.5 rounded-full ${
                  feed.status === 'Active' ? 'bg-emerald-400' : 'bg-red-400'
                }`} />
                {feed.status}
              </span>
            </div>
            <p className="text-sm font-medium text-white mb-3 truncate" title={feed.name}>{feed.name}</p>
            <div className="space-y-1.5 text-xs text-gray-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  <span>Last Sync</span>
                </div>
                <span className="font-mono">{feed.lastSync}</span>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <BarChart className="w-3 h-3" />
                  <span>Indicators</span>
                </div>
                <span className="font-mono text-white">{feed.indicators.toLocaleString()}</span>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <Activity className="w-3 h-3" />
                  <span>Frequency</span>
                </div>
                <span className="font-mono">{feed.frequency}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default FeedMonitoring;
